import store from '@/store'
const {currentUser} = store.state
export const IS_PROVIDER_ACCOUNT = currentUser && currentUser.account_type === 'provider'
import {userRoleIs, SPECIALIST, ADMINISTRATIVE} from "../utils/Specialist";

export const dashboardComponentName = () => {

    //some logic
    if(userRoleIs(SPECIALIST)){
        return 'SpecialistDashboard'
    }

    if(userRoleIs(ADMINISTRATIVE)){
        return 'AdministrativeDashboard'
    }

    return 'BasicProviderDashboard'
}